var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveStepIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.5C17.125 19.5 20.5 16.125 20.5 12C20.5 7.875 17.125 4.5 13 4.5C8.875 4.5 5.5 7.875 5.5 12C5.5 16.125 8.875 19.5 13 19.5Z",
    fill: "#F0F7FF",
    stroke: "#ADD7FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveStepIcon);
export default __webpack_public_path__ + "static/media/inactive-step-icon.eb46d875d7174254081a448aaaec5b8a.svg";
export { ForwardRef as ReactComponent };